var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.78361 0.306658C1.37559 -0.102219 0.714045 -0.102219 0.306019 0.306658C-0.102007 0.715534 -0.102006 1.37846 0.30602 1.78733L5.50783 6.99999L0.30602 12.2127C-0.102006 12.6215 -0.102007 13.2844 0.306019 13.6933C0.714045 14.1022 1.37559 14.1022 1.78361 13.6933L7.69398 7.77063C7.90569 7.55849 8.00755 7.27795 7.99957 6.99999C8.00755 6.72203 7.90569 6.4415 7.69398 6.22935L1.78361 0.306658Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.e2f9d0b59c0b341b9a5d74abc40c3dfa.svg";
export { ForwardRef as ReactComponent };